const home = {
    welcome: '欢迎来到 EasyHireAi',
    description: '这是一个基于 Vue 3 + TypeScript + shadcn-vue + Tailwind CSS 的管理后台。',
  }

export default home
